exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._2EnkztYuLloQ5rk0-PPXSV {\n  font-weight: bold;\n}\n", ""]);

// exports
exports.locals = {
	"Term": "_2EnkztYuLloQ5rk0-PPXSV"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1!./~/cssnext-loader!./src/Highlighter.css
 ** module id = 161
 ** module chunks = 0
 **/